import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { Reveal, MaskReveal } from "@/components/Reveal";
import { LEGAL_PAGES } from "@/data/content";

const LegalPage = () => {
  const { page } = useParams();
  const legal = LEGAL_PAGES[page];

  useEffect(() => {
    if (legal) document.title = `${legal.title} | T Plus One`;
  }, [legal]);

  if (!legal) return <Navigate to="/" replace />;

  return (
    <main className="pt-32 lg:pt-40 pb-24 lg:pb-32" data-testid={`legal-${page}`}>
      <div className="container-x max-w-3xl">
        <Reveal><p className="eyebrow">Legal</p></Reveal>
        <MaskReveal as="h1" lines={[legal.title]} className="mt-6 text-4xl sm:text-5xl tracking-tight" />
        <Reveal delay={0.15}>
          <p className="mt-6 inline-block rounded-full border border-line bg-subtle px-4 py-2 font-mono text-[11px] uppercase tracking-[0.15em] text-tertiary" data-testid="legal-template-note">
            {legal.note}
          </p>
        </Reveal>
        <div className="mt-14 space-y-12">
          {legal.sections.map((s, i) => (
            <Reveal key={s.heading} delay={i * 0.05}>
              <section>
                <h2 className="text-xl sm:text-2xl tracking-tight">{s.heading}</h2>
                <p className="mt-4 text-base text-dim leading-relaxed">{s.body}</p>
              </section>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-16 pt-10 border-t border-line">
          <p className="text-xs text-tertiary leading-relaxed">Last updated: 2026. For questions about this document, contact T Plus One through the contact page.</p>
        </Reveal>
      </div>
    </main>
  );
};

export default LegalPage;
